angular
  .module('capability-ng-scheduler')
  .factory('SuggestionsBuilder', function SuggestionsBuilder(Interface, $injector, isCheckTimeWithInstructor) {
    'use strict';

    var DTD = {
      unchecked_campuses: {
        type: 'array'
      },
      schedule: {
        type: 'array'
      },
      schedule_completeness: {
        type: 'string'
      },
      selected_sections: {
        type: 'array'
      },
      term: {
        type: 'ngObject',
        typeDef: 'TermBuilder'
      },
      course: {
        type: 'ngObject',
        typeDef: 'CourseBuilder'
      },
      section: {
        type: 'ngObject',
        typeDef: 'SectionBuilder'
      },
      sectiontime: {
        type: 'ngObject',
        typeDef: 'SectionTimeBuilder'
      },
      location: {
        type: 'ngObject',
        typeDef: 'LocationBuilder'
      },
      campus: {
        type: 'ngObject',
        typeDef: 'CampusBuilder'
      },
      sectionstatus: {
        type: 'ngObject',
        typeDef: 'SectionStatusBuilder'
      }
    };

    function SuggestionsDTO(raw) {
      Interface.implement(DTD, raw, this);
      $injector.get('campusToLocationMappingFn').call(this, raw);

      $injector.get('locationToSectiontimeMappingFn').call(this, raw);
      $injector.get('sortSectionTimesByDayOfWeek').call(this, raw);
      $injector.get('sectiontimeToSectionMappingFn').call(this, raw);
      $injector.get('timeAndDateDisplayToSectiontimeMappingFn').call(this, raw);

      $injector.get('campusToSectionMappingFn').call(this, raw);
      $injector.get('sectionstatusToSectionMappingFn').call(this, raw);
      $injector.get('sectionTypeNameToSectionMappingFn').call(this, raw);

      campusToUncheckedCampusesMappingFn.call(this, raw);
      courseToSectionMappingFn.call(this, raw);
      sectionToScheduleMappingFn.call(this, raw);
    }

    /**
     * @post get course and add to section object for easy access
     */
    var campusToUncheckedCampusesMappingFn = function campusToUncheckedCampusesMappingFn(data) {
      this._unchecked_campuses = [];
      _.each(
        data.unchecked_campuses,
        function (campusId) {
          this._unchecked_campuses.push(_.find(data.campus, { id: campusId }));
        },
        this
      );
    };

    /**
     * @post get course and add to section object for easy access
     */
    var courseToSectionMappingFn = function courseToSectionMappingFn(data) {
      _.each(
        data.section,
        function (section) {
          this[section.id]._course = _.find(data.course, { id: section.course });
        },
        this.section
      );
    };

    /**
     * @post create suggested schedules with sections (2-dimensional array)
     */
    var sectionToScheduleMappingFn = function sectionToScheduleMappingFn(data) {
      this._schedules = [];
      _.each(
        data.schedule,
        function (schedule) {
          var _sections = [];
          _.each(schedule, function (sectionId) {
            var fullSection = _.find(data.section, { id: sectionId });
            if (!isCheckTimeWithInstructor.areTimesNotSpecified(fullSection._section_times)) {
              _sections.push(fullSection);
            }
          });
          this._schedules.push(_sections);
        },
        this
      );
    };

    return SuggestionsDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/builders/suggestions_builder.js